import { IStore } from '../../../common/store';

const optionsSelectors = {
  getOptionsLoadingState: (state: IStore) => state.customiseCombinedReducer.optionsReducer.loading,
  getOptionsErrorState: (state: IStore) => state.customiseCombinedReducer.optionsReducer.error,
  getOptions: (state: IStore) => state.customiseCombinedReducer.optionsReducer.options,
  getAccessoriesCategories: (state: IStore) => state.customiseCombinedReducer.optionsReducer.accessoriesCategories,
  getAccessoryPacks: (state: IStore) => state.customiseCombinedReducer.optionsReducer.accessoryPacks,
};

export default optionsSelectors;
